import React, { useState, useEffect } from "react";
import StockSummary from "../../components/layout/stock/StockSummary";
import NewsList from "../../components/common/NewsList";
import {
  getIndustryNThemeNewsAPI,
  getRealtimeNewsAPI,
  getStockDataAPI,
} from "../../apis/news_service";
import Loading from "../error/Loading";

import NineMemosReports from "./ninememosReports";

const StockPage = () => {
  const path = window.location.pathname;
  const stockcode = path.split("/")[2];

  const [data, setData] = useState(null); //종목명 큐레이팅 데아터

  const [loading, setLoading] = useState(true);
  const [stockNews, setStockNews] = useState([]);
  const [themeNews, setThemeNews] = useState([]);

  const params = {
    stockcode: stockcode,
    size: 5,
  };

  const getStockData = (code) => {
    getStockDataAPI(code)
      .then((res) => {
        setData(res);
        return res;
      })
      .then((res) => {
        getRealtimeNewsAPI(params).then((res) => {
          setStockNews(res);
        });
        getIndustryNThemeNewsAPI("industry", res.FICS_sub).then((res) => {
          setThemeNews(res);
          setLoading(false);
        });
      });
  };

  useEffect(() => {
    if (stockcode === undefined) {
    } else {
      getStockData(stockcode);
    }
  }, [stockcode]);

  return (
    <div className="container">
      <div className="stock inner_container">
        {data && (
          <>
            <StockSummary stock={data} />
            <NineMemosReports stockcode={stockcode} />
            {loading ? (
              <Loading />
            ) : (
              <>
                <div className="stock_news_container">
                  <p className="title_sm">{data.stockname} 뉴스</p>
                  <NewsList newsList={stockNews} type="vertical" size="5" />
                </div>

                <div className="theme_news_container">
                  <p className="title_sm">관련 산업과 테마 뉴스</p>
                  <NewsList newsList={themeNews} type="vertical" size="5" />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StockPage;
